import {
	IBM_Plex_Sans,
	Inconsolata,
	Inter,
	Merriweather,
	Montserrat,
	Nunito,
	Roboto,
} from "next/font/google";

const roboto = Roboto({
	weight: ["300", "500", "700"],
	subsets: ["latin", "latin-ext"],
	preload: false,
});
const robotoUrl = `https://fonts.googleapis.com/css2?family=Roboto:wght@300;500;700&display=swap`;

const inter = Inter({
	weight: "variable",
	subsets: ["latin", "latin-ext"],
	preload: false,
});
const interUrl = `https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap`;

const merriweather = Merriweather({
	weight: ["300", "400", "700"],
	subsets: ["latin", "latin-ext"],
	preload: false,
});
const merriweatherUrl = `https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&display=swap`;

const montserrat = Montserrat({
	weight: ["300", "400", "700"],
	subsets: ["latin", "latin-ext"],
	preload: false,
});
const montserratUrl = `https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;700&display=swap`;

const nunito = Nunito({
	weight: ["300", "400", "700"],
	subsets: ["latin", "latin-ext"],
	preload: false,
});
const nunitoUrl = `https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;700&display=swap`;

const inconsolata = Inconsolata({
	weight: "variable",
	subsets: ["latin", "latin-ext"],
	preload: false,
});
const inconsolataUrl = `https://fonts.googleapis.com/css2?family=Inconsolata:wght@200..900&display=swap`;

const ibmPlexSans = IBM_Plex_Sans({
	weight: "variable",
	subsets: ["latin", "latin-ext"],
	preload: false,
});
const ibmPlexSansUrl = `https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100..700;1,100..700&display=swap`;

export const fonts = { roboto, inter, merriweather, montserrat, nunito, inconsolata, ibmPlexSans };
export const fontUrls = {
	roboto: robotoUrl,
	inter: interUrl,
	merriweather: merriweatherUrl,
	montserrat: montserratUrl,
	nunito: nunitoUrl,
	inconsolata: inconsolataUrl,
	ibmPlexSans: ibmPlexSansUrl,
} satisfies Record<keyof typeof fonts, string>;
